<div class="presenterContainer-b">
    <div class="content-title">
        <h1 class="title">{{car.brand}} {{car.subBrand}}</h1>
    </div>
    <p class="version">{{car.version}} {{car.year}}</p>
    <ng-container *ngIf="screenSize > 767;else carouselMobile">
        <div id="imagePresenterLg" class="container-fluid">
            <div class="mainImageLg">
                <img [ngClass]="{'not-found': images.imagenes.length === 0}"
                    src="{{images.imagenes.length > 0 ? mainImageUrl : './assets/img/auto_no_disponible.svg'}}"
                    alt="brand image">
            </div>
            <div class="presenterCarouselLg arrows-rect" *ngIf="images.imagenes.length > 0">
                <carousel [arrows]="true" [arrowsOutside]="true" [cellWidth]="'100%'" [height]="85" [autoplay]="false"
                    [cellsToShow]="4" [cellsToScroll]="1" [margin]="0" [transitionTimingFunction]="'ease-in-out'"
                    [transitionDuration]="1000">
                    <div class="carousel-cell" *ngFor="let image of images.imagenes" (mouseover)="setMainImg(image)">
                        <img src="{{image}}" alt="brand image">
                    </div>
                    <div class="carousel-cell" *ngIf="car.urlVideo">
                        <img src="https://cms.bitcar.mx/uploads/img_video_preview_mobile_e1c9a45c73.jpg" alt="brand image">
                        <div class="middle">
                            <div class="overlayimg">
                                <img class="p-1" src="./assets/home/play-white.svg" alt="car image"
                                    (click)="summaryService.openVideo(car.urlVideo, 'Video ' + car.brand + ' ' + car.subBrand)">
                            </div>
                        </div>
                    </div>
                </carousel>
            </div>
        </div>
    </ng-container>

    <ng-template #carouselMobile>
        <div id="imagePresenterLg" class="container-fluid">
            <div class="mainImageLg">
                <img [ngClass]="{'not-found': images.imagenes.length === 0}"
                    src="{{images.imagenes.length > 0 ? mainImageUrl : './assets/img/auto_no_disponible.svg'}}"
                    alt="brand image">
            </div>
            <div class="presenterCarouselLg arrows-rect" *ngIf="images.imagenes.length > 0">
                <carousel [arrows]="false" [cellWidth]="90" [height]="85" [cellsToScroll]="1"
                    [transitionTimingFunction]="'ease-in-out'" [transitionDuration]="1000">
                    <div class="carousel-cell" *ngFor="let image of images.imagenes" (mouseover)="setMainImg(image)">
                        <div class="card-car">
                            <img src="{{image}}" alt="brand image">
                        </div>
                    </div>
                    <div class="carousel-cell" *ngIf="car.urlVideo">
                        <div class="card-car">
                            <img src="https://cms.bitcar.mx/uploads/img_video_preview_mobile_e1c9a45c73.jpg"
                                (click)="summaryService.openVideo(car.urlVideo, 'Video ' + car.brand + ' ' + car.subBrand)"
                                alt="brand image video">
                        </div>
                    </div>
                </carousel>
            </div>
        </div>
    </ng-template>
</div>